import { Component } from '@angular/core';
import { DtoInstallmentForViewVM } from '../../../Model/DtoInstallmentForViewVM';
import { AuthService } from '../../../Shared/Services/auth.service';
import { InstallmentService } from '../../../Services/installment.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { UserType } from '../../../Shared/Enums/UserType';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-modify-payments',
  templateUrl: './modify-payments.component.html',
  styleUrl: './modify-payments.component.scss'
})
export class ModifyPaymentsComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  InstallmentsList!: DtoInstallmentForViewVM[];
  contractId?: number = 0;
  constructor(private api: InstallmentService, private auth: AuthService, private spinner: NgxSpinnerService, private route: ActivatedRoute,
    private router: Router, private toastrService: CustomToastrService, private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.route.params.subscribe(params => {
        const id = params['id'];
        this.GetAllInstallmentByContractId(id);
      });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllInstallmentByContractId(contractId?: number) {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.api.GetAllInstallmentByContractId(contractId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.InstallmentsList = data;
              this.contractId = contractId;
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  UpdateInstallment(installmentId?: number) {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'ConfirmPayment',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.spinner.show();
        this.ConfirmUpdateInstallment(installmentId);
      }
    });
  }

  ConfirmUpdateInstallment(installmentId?: number) {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.api.UpdateInstallment(installmentId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              if (data) {
                this.toastrService.showSuccessToast('Success', 'UpdateInstallmentSuccessfully');
                this.GetAllInstallmentByContractId(this.contractId);
              } else {
                this.toastrService.showErrorToast('Error', data.message);
              }
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  Cancel() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoBack',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.router.navigateByUrl('dashboard/follow-installments');
      }
    });
  }
}
